import { AppIcon } from '@/components/AppIcon';
import { STATES } from './states';

/** A state such as "PENDING" or "ACTIVE", shown as words and a colour. Any
 *  state not listed still shows, just in plain title case. */
export function StatePill({ state, label }: { state: string; label?: string }) {
  const s = STATES[state];
  const tone = s?.tone ?? 'plain';
  return (
    <span className={`pill${tone === 'plain' ? '' : ` pill--${tone}`}`}>
      {s && <AppIcon kind={s.icon} size={12} />}
      {label ?? s?.label ?? state.charAt(0) + state.slice(1).toLowerCase()}
    </span>
  );
}
